import { useContext, useEffect, useState } from "react";
import { Container, Col, Row, Image, Card, Button } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { fetchOneDetails } from "../http/detailAPI";
import { Context } from "../index";
import '../css/skeleton_loading.css'
import '../css/detailpage.css';

const DetailPage = () => {
    const { basket } = useContext(Context);
    const [detail, setDetail] = useState({ info: [] });
    const [isLoading, setIsLoading] = useState(true);
    const { id } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
        setIsLoading(true);
        fetchOneDetails(id)
            .then(data => setDetail(data))
            .finally(() => setIsLoading(false));
    }, [id]);

    const addToBasket = () => {
        const basketItem = {
            id: detail.id,
            name: detail.name,
            price: detail.price,
            img: detail.img,
            brand: detail.brand,
            type: detail.type,
            info: detail.info
        };
        basket.addBasketItem(basketItem);
        alert('Товар добавлен в корзину');
    };

    const skeletonInfoCount = 5;
    return (
        <Container 
                className="py-5" 
                style={{ 
                    minHeight: '80vh',
                    height: isLoading ? '100vh' : 'auto',
                    overflow: isLoading ? 'hidden' : 'visible'
                }}
            >
            <Card className="card-custom">
                <Row className="g-0">
                    <Col md={6} className="p-4">
                        <div className="image-container" style={{ width: '100%', height: '300px' }}>
                            {isLoading ? (
                                <div className="skeleton skeleton-image" style={{ width: '100%', height: '100%' }} />
                            ) : (
                                <Image
                                    className="detail-image img-fluid"
                                    src={process.env.REACT_APP_API_URL + 'static/' + detail.img}
                                    alt={detail.name}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            )}
                        </div>
                    </Col>
                    <Col md={6} className="p-4">
                        <div className="d-flex flex-column h-100">
                            <div className="mb-4">
                                {isLoading ? (
                                    <>
                                        <div className="skeleton skeleton-text mb-2" style={{ width: '60%', height: '16px' }} />
                                        <div className="skeleton skeleton-text" style={{ width: '80%', height: '28px', marginBottom: '24px' }} />
                                    </>
                                ) : (
                                    <>
                                        <span className="detail-type-brand">
                                            {detail.type?.name} • {detail.subType?.name || ''} • {detail.brand?.name}
                                        </span>
                                        <h1 className="detail-name">
                                            {detail.name || "Название отсутствует"}
                                        </h1>
                                    </>
                                )}
                            </div>
                            <div className="mb-4">
                                {isLoading ? (
                                    <div className="skeleton skeleton-text mb-3" style={{ width: '40%', height: '32px' }} />
                                ) : (
                                    <h2 className="detail-price">
                                        {detail.price ? `${detail.price}₽` : "Цена по запросу"}
                                    </h2>
                                )}
                                <Button
                                    className="basket_button"
                                    variant="custom"
                                    onClick={addToBasket}
                                    disabled={isLoading}
                                    style={{ width: '200px' }}
                                >
                                    {isLoading ? <div className="skeleton skeleton-button" style={{ width: '100%', height: '100%' }} /> : 'Добавить в корзину'}
                                </Button>
                            </div>
                            <div className="delivery_select_mobile">
                                {isLoading ? (
                                    <>
                                        <div className="skeleton skeleton-text mb-2" style={{ width: '70%', height: '20px' }} />
                                        <div className="skeleton skeleton-text mb-1" style={{ width: '90%', height: '16px' }} />
                                        <div className="skeleton skeleton-text mb-1" style={{ width: '80%', height: '16px' }} />
                                        <div className="skeleton skeleton-text mb-1" style={{ width: '70%', height: '16px' }} />
                                        <div className="skeleton skeleton-text mb-3" style={{ width: '60%', height: '16px' }} />
                                        <div className="skeleton skeleton-text mb-2" style={{ width: '60%', height: '20px' }} />
                                        <div className="skeleton skeleton-text mb-1" style={{ width: '70%', height: '16px' }} />
                                        <div className="skeleton skeleton-text" style={{ width: '50%', height: '16px' }} />
                                    </>
                                ) : (
                                    <>
                                        <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по Екатеринбургу и обл:</h4>
                                        <ul style={{paddingLeft: 10}}>
                                            <li style={{listStyle: 'inside'}}>Досталвяем заказы от 30000₽</li>
                                            <li style={{listStyle: 'inside'}}>Заказы от 50000₽ - бесплатно</li>
                                            <li style={{listStyle: 'inside'}}>По Екатеринбургу - 1500₽</li>
                                            <li style={{listStyle: 'inside'}}>Удаленные районы - 2000₽</li>
                                        </ul>
                                        <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по России:</h4>
                                        <ul style={{paddingLeft: 10}}>
                                            <li style={{listStyle: 'inside'}}>В рабочие дни Пн-Пт</li>
                                            <li style={{listStyle: 'inside'}}>ТК Деловые Линии.</li>
                                            <li style={{listStyle: 'inside'}}>ТК Кит и др.</li>
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Card>
            
            <Card className="mt-4 card-custom delivery_select">
                <Card.Body className="p-4">
                    {isLoading ? (
                        <Row>
                            <Col xs={6}>
                                <div className="skeleton skeleton-text mb-2" style={{ width: '70%', height: '20px' }} />
                                <div className="skeleton skeleton-text mb-1" style={{ width: '90%', height: '16px' }} />
                                <div className="skeleton skeleton-text mb-1" style={{ width: '80%', height: '16px' }} />
                                <div className="skeleton skeleton-text mb-1" style={{ width: '70%', height: '16px' }} />
                                <div className="skeleton skeleton-text" style={{ width: '60%', height: '16px' }} />
                            </Col>
                            <Col xs={6}>
                                <div className="skeleton skeleton-text mb-2" style={{ width: '60%', height: '20px' }} />
                                <div className="skeleton skeleton-text mb-1" style={{ width: '70%', height: '16px' }} />
                                <div className="skeleton skeleton-text" style={{ width: '50%', height: '16px' }} />
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col xs={6}>
                                <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по Екатеринбургу и обл:</h4>
                                <ul style={{paddingLeft: 10}}>
                                    <li style={{listStyle: 'inside'}}>Досталвяем заказы от 30000₽</li>
                                    <li style={{listStyle: 'inside'}}>Заказы от 50000₽ - бесплатно</li>
                                    <li style={{listStyle: 'inside'}}>По Екатеринбургу - 1500₽</li>
                                    <li style={{listStyle: 'inside'}}>Удаленные районы - 2000₽</li>
                                </ul>
                            </Col>
                            <Col xs={6}>
                                <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по России:</h4>
                                <ul style={{paddingLeft: 10}}>
                                    <li style={{listStyle: 'inside'}}>В рабочие дни Пн-Пт</li>
                                    <li style={{listStyle: 'inside'}}>ТК Деловые Линии.</li>
                                    <li style={{listStyle: 'inside'}}>ТК Кит и др.</li>
                                </ul>
                            </Col>
                        </Row>
                    )}
                </Card.Body>
            </Card>
            
            <Card className="mt-4 card-custom">
                <Card.Body className="p-4">
                    <h3 className="characteristics-title">
                        {isLoading ? (
                            <div className="skeleton skeleton-text" style={{ width: '40%', height: '28px', marginBottom: '20px' }} />
                        ) : 'Характеристики'}
                    </h3>
                    
                    {isLoading ? (
                        Array(skeletonInfoCount).fill(0).map((_, index) => (
                            <Row key={`skeleton-${index}`} className="characteristic-row mb-3">
                                <Col xs={4}>
                                    <div className="skeleton skeleton-text" style={{ width: '80%', height: '20px' }} />
                                </Col>
                                <Col xs={8}>
                                    <div className="skeleton skeleton-text" style={{ width: '90%', height: '20px' }} />
                                </Col>
                            </Row>
                        ))
                    ) : (
                        detail.info.map((info) => (
                            <Row key={info.id} className="characteristic-row">
                                <Col xs={4} className="characteristic-title">
                                    {info.title}
                                </Col>
                                <Col xs={8}>
                                    {info.description}
                                </Col>
                            </Row>
                        ))
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default DetailPage;